import clsx from 'clsx';
import Image from 'next/image';
import checkPng from '../../assets/images/rewards-program/check.png';

const BenefitsTable = props => {
  const { hideTitle, levelIndex, levelCol } = props;

  const renderLevelCol = levelCol || [
    'Birthday Gift',
    <>
      <span className='hidden lg_inline'>Exclusive Redeem Points</span>
      <div className='lg_hidden'>Exclusive</div>
      <div className='lg_hidden'>Redeem Points</div>
    </>,
    //   'Level-up Coupon',
    <>
      <span className='hidden lg_inline'>1 Point For Every $1 Spent</span>
      <div className='lg_hidden'>1 Point For Every</div>
      <div className='lg_hidden'>$1 Spent</div>
    </>,
    <>
      <span className='hidden lg_inline'>Amazon Order Redeem</span>
      <div className='lg_hidden'>Amazon Order</div>
      <div className='lg_hidden'>Redeem</div>
    </>,
    <>
      <span className='hidden lg_inline'>Lifetime Warranty</span>
      <div className='lg_hidden'>Lifetime</div>
      <div className='lg_hidden'>Warranty</div>
    </>,
    <>
      <span className='hidden lg_inline'>Exclusive Customer Service</span>
      <div className='lg_hidden'>Exclusive</div>
      <div className='lg_hidden'>Customer Service</div>
    </>,
    <>
      <span className='hidden lg_inline'>Prioritize Feedback</span>
      <div className='lg_hidden'>Prioritize</div>
      <div className='lg_hidden'>Feedback</div>
    </>,
    <>
      <span className='hidden lg_inline'>Free Product Testing Chances</span>
      <div className='lg_hidden'>Free Product</div>
      <div className='lg_hidden'>Testing Chances</div>
    </>,
    <>
      <span className='hidden lg_inline'>Exclusive Christmas Gifts</span>
      <div className='lg_hidden'>Exclusive</div>
      <div className='lg_hidden'>Christmas Gifts</div>
    </>,
  ];

  return (
    <div className={clsx('font-poppins', props.className)}>
      <h2
        className={clsx(
          'text-center font-poppins text-lg font-[600] text-primary lg_text-[30px]',
          hideTitle ? 'hidden' : '',
        )}
      >
        KINGSYARD VIP BENEFITS
      </h2>

      <section
        className={clsx(
          'ml-2.5 mt-5 flex max-w-[1440px]  min-[720px]_mx-2.5 lg_mt-[50px] min-[1440px]_mx-auto',
          'border-b-1 border-solid border-[#ddd] lg_border-none',
          hideTitle && 'lg_mt-0',
          levelIndex === 3 ? 'overflow-y-clip' : 'overflow-hidden',
        )}
      >
        <ul
          className={clsx(
            'min-[720px]_shadow-none relative min-w-[140px] flex-[1] font-sans shadow-[2px_0_5px_rgba(0,0,0,.2)] ',
          )}
        >
          <li
            className={clsx(
              'flex  h-[80px] flex-1 flex-col items-center justify-center  lg_h-[120px] ',
              'bg-primary',
              'border-r-1 border-solid border-[#ddd] lg_border-none',
              '  font-poppins text-sm font-normal text-white lg_text-[16px]',
            )}
          >
            LEVEL
          </li>

          {renderLevelCol.map((x, i) => {
            return (
              <li
                key={i}
                className={clsx(
                  'flex h-[50px] flex-1 flex-col items-center justify-center lg_h-[80px]',
                  i % 2 === 0 ? 'bg-white lg_bg-[#F8F8F8]' : 'bg-[#EFEFEF] lg_bg-[#EFEFEF]',
                  ' border-l-1 border-r-1 border-solid border-[#ddd] lg_border-none',
                  'text-center font-sans  text-sm font-medium text-title lg_text-[16px] lg_font-semibold',
                )}
              >
                {x}
              </li>
            );
          })}
        </ul>

        <div
          className={clsx(
            'flex-[4] overflow-x-auto',
            levelIndex === 0 && 'relative shadow-[-17px_0_34px_33px_rgba(0,0,0,.1)]',
            levelIndex === 3 && 'relative shadow-[34px_0_34px_0px_rgba(0,0,0,.1)]',
          )}
        >
          <div className=' flex min-w-[560px]'>
            <ul className={clsx(' flex-1', levelIndex === 0 && 'relative shadow-[0_0_34px_33px_rgba(0,0,0,.1)]')}>
              <li
                className={clsx(
                  'flex h-[80px]  flex-1 flex-col items-center justify-center',
                  'bg-accent',
                  'border-r-1 border-solid border-[#ddd] lg_border-none',
                  'text-sm font-normal text-white',
                  'lg_h-[120px] lg_bg-primary lg_text-[16px]',
                  levelIndex === 0 ? 'lg_bg-secondary' : 'lg_bg-primary',
                )}
              >
                <div className='text-center'>K0</div>
                <div className='text-center'>NEW MEMBERS</div>
              </li>

              {[
                '50 Points',
                <>
                  <span className='hidden lg_inline'>Subscribe 10% OFF</span>
                  <div className='lg_hidden'>Subscribe 10%</div>
                  <div className='lg_hidden'>OFF</div>
                </>,
                // '10% OFF',
              ]
                .concat(
                  Array.from(
                    {
                      length: 5,
                    },
                    (_, i) => (
                      <Image
                        alt='check'
                        src={checkPng}
                        width={32}
                        height={20}
                        className='scale-[.8] lg_scale-100'
                        key={i + 3}
                      />
                    ),
                  ),
                  Array.from(
                    {
                      length: 2,
                    },
                    (_, i) => (
                      <UnCheck
                        key={i + 9}
                        levelIndex={levelIndex}
                        activeLevelIndex={0}
                      />
                    ),
                  ),
                )
                .map((x, i) => {
                  return (
                    <li
                      key={i}
                      className={clsx(
                        'flex h-[50px] flex-1 flex-col items-center justify-center lg_h-[80px]',
                        i % 2 === 0 ? 'bg-white lg_bg-[#F8F8F8]' : 'bg-[#EFEFEF] lg_bg-[#EFEFEF]',
                        'border-r-1 border-solid border-[#ddd] lg_border-none',
                        'text-center font-sans text-sm font-medium text-title ',
                        levelIndex === 0
                          ? 'font-poppins uppercase lg_bg-white lg_text-base lg_font-normal'
                          : 'lg_text-[16px] lg_font-semibold',
                      )}
                    >
                      {x}
                    </li>
                  );
                })}
            </ul>

            <ul className={clsx(' flex-1', levelIndex === 1 && 'relative shadow-[0_0_34px_33px_rgba(0,0,0,.1)]')}>
              <li
                className={clsx(
                  'flex h-[80px]  flex-1 flex-col items-center justify-center',
                  'bg-accent ',
                  'border-r-1 border-solid border-[#ddd] lg_border-none',
                  'text-sm font-normal text-white',
                  'lg_h-[120px] lg_bg-primary lg_text-[16px]',
                  levelIndex === 1 ? 'lg_bg-secondary' : 'lg_bg-primary',
                )}
              >
                <div className='text-center'>K1</div>
                <div className='text-center'>ANNUAL SPEND</div>
                <div className='text-center'>$1-$199</div>
              </li>

              {[
                '100 Points',
                <>
                  <span className='hidden lg_inline'>Exclusive 15% OFF</span>
                  <div className='lg_hidden'>Exclusive 15%</div>
                  <div className='lg_hidden'>OFF</div>
                </>,
                // '15% OFF',
              ]
                .concat(
                  Array.from(
                    {
                      length: 6,
                    },
                    (_, i) => (
                      <Image
                        alt='check'
                        src={checkPng}
                        width={32}
                        height={20}
                        className='scale-[.8] lg_scale-100'
                        key={i + 3}
                      />
                    ),
                  ),
                  <UnCheck
                    levelIndex={levelIndex}
                    activeLevelIndex={1}
                  />,
                )
                .map((x, i) => {
                  return (
                    <li
                      key={i}
                      className={clsx(
                        'flex h-[50px] flex-1 flex-col items-center justify-center lg_h-[80px]',
                        i % 2 === 0 ? 'bg-white lg_bg-[#F8F8F8]' : 'bg-[#EFEFEF] lg_bg-[#EFEFEF]',
                        'border-r-1 border-solid border-[#ddd] lg_border-none',
                        'text-center font-sans  text-sm font-medium text-title',
                        levelIndex === 1
                          ? 'font-poppins uppercase lg_bg-white lg_text-base lg_font-normal'
                          : 'lg_text-[16px] lg_font-semibold',
                      )}
                    >
                      {x}
                    </li>
                  );
                })}
            </ul>

            <ul className={clsx(' flex-1', levelIndex === 2 && 'relative shadow-[0_0_34px_33px_rgba(0,0,0,.1)]')}>
              <li
                className={clsx(
                  'flex h-[80px]  flex-1 flex-col items-center justify-center',
                  'bg-accent ',
                  'border-r-1 border-solid border-[#ddd] lg_border-none',
                  'text-sm font-normal text-white',
                  'lg_h-[120px] lg_bg-primary lg_text-[16px]',
                  levelIndex === 2 ? 'lg_bg-secondary' : 'lg_bg-primary',
                )}
              >
                <div className='text-center'>K2</div>
                <div className='text-center'>ANNUAL SPEND</div>
                <div className='text-center'>$200-$499</div>
              </li>

              {[
                '200 Points',
                <>
                  <span className='hidden lg_inline'>Exclusive 20% OFF</span>
                  <div className='lg_hidden'>Exclusive 20%</div>
                  <div className='lg_hidden'>OFF</div>
                </>,
                // '20% OFF',
              ]
                .concat(
                  Array.from(
                    {
                      length: 6,
                    },
                    (_, i) => (
                      <Image
                        alt='check'
                        src={checkPng}
                        width={32}
                        height={20}
                        className='scale-[.8] lg_scale-100'
                        key={i + 3}
                      />
                    ),
                  ),
                  <UnCheck
                    levelIndex={levelIndex}
                    activeLevelIndex={2}
                  />,
                )
                .map((x, i) => {
                  return (
                    <li
                      key={i}
                      className={clsx(
                        'flex h-[50px] flex-1 flex-col items-center justify-center lg_h-[80px]',
                        i % 2 === 0 ? 'bg-white lg_bg-[#F8F8F8]' : 'bg-[#EFEFEF] lg_bg-[#EFEFEF]',
                        'border-r-1 border-solid border-[#ddd] lg_border-none',
                        'text-center font-sans  text-sm font-medium text-title',
                        levelIndex === 2
                          ? 'font-poppins uppercase lg_bg-white lg_text-base lg_font-normal'
                          : 'lg_text-[16px] lg_font-semibold',
                      )}
                    >
                      {x}
                    </li>
                  );
                })}
            </ul>

            <ul className={clsx(' flex-1', levelIndex === 3 ? 'relative shadow-[0_0_34px_33px_rgba(0,0,0,.1)]' : '')}>
              <li
                className={clsx(
                  'flex h-[80px]  flex-1 flex-col items-center justify-center',
                  'bg-accent ',
                  'border-r-1 border-solid border-[#ddd] lg_border-none',
                  'text-sm font-normal text-white',
                  'lg_h-[120px] lg_bg-primary lg_text-[16px]',
                  levelIndex === 3 ? 'lg_bg-secondary' : 'lg_bg-primary',
                )}
              >
                <div className='text-center'>K3</div>
                <div className='text-center'>ANNUAL SPEND</div>
                <div className='text-center'>OVER $500</div>
              </li>

              {[
                '300 Points',
                <>
                  <span className='hidden lg_inline'>Exclusive 25% OFF</span>
                  <div className='lg_hidden'>Exclusive 25%</div>
                  <div className='lg_hidden'>OFF</div>
                </>,
                // '25% OFF',
              ]
                .concat(
                  Array.from(
                    {
                      length: 7,
                    },
                    (_, i) => (
                      <Image
                        alt='check'
                        src={checkPng}
                        width={32}
                        height={20}
                        className='scale-[.8] lg_scale-100'
                        key={i + 3}
                      />
                    ),
                  ),
                )
                .map((x, i) => {
                  return (
                    <li
                      key={i}
                      className={clsx(
                        'flex h-[50px] flex-1 flex-col items-center justify-center lg_h-[80px]',
                        i % 2 === 0 ? 'bg-white lg_bg-[#F8F8F8]' : 'bg-[#EFEFEF] lg_bg-[#EFEFEF]',
                        'border-r-1 border-solid border-[#ddd] lg_border-none',
                        'text-center font-sans  text-sm font-medium text-title',
                        levelIndex === 3
                          ? 'font-poppins uppercase lg_bg-white lg_text-base lg_font-normal'
                          : 'lg_text-[16px] lg_font-semibold',
                      )}
                    >
                      {x}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

const UnCheck = props => {
  const { levelIndex, activeLevelIndex } = props;

  return (
    <div
      className={clsx(
        'relative h-0 w-0',
        'before_absolute before_left-1/2 before_top-1/2  before_h-[6px] before_w-[25px]',
        'before_-translate-x-1/2 before_-translate-y-1/2 before_content-[""]',
        'after_absolute after_left-1/2 after_top-1/2  after_h-[6px] after_w-[25px]',
        'after_-translate-x-1/2 after_-translate-y-1/2 after_content-[""]',
        'before_rotate-45 after_-rotate-45',
        'scale-[.8] lg_scale-100',
        levelIndex === undefined
          ? 'before_bg-[#656363] after_bg-[#656363]'
          : levelIndex === activeLevelIndex
            ? 'before_bg-primary after_bg-primary'
            : 'before_bg-info after_bg-info',
      )}
    />
  );
};

export default BenefitsTable;
